import { inject, Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { map, switchMap } from "rxjs";
import { Store } from "@ngrx/store";
import { Paginate } from "../../../models/pagination.model";
import { PlatformManagerService } from "../service/platform-manager.service";
import { Tenant } from "../models/tenant.model";
import { platformManagerActions } from "./platform-manager.actions";

@Injectable()
export class PlatformManagerEffects {
  private readonly actions$ = inject(Actions);
  private readonly store = inject(Store);
  private readonly platfromManagerService = inject(PlatformManagerService);

  getTenants$ = createEffect(() =>
    this.actions$.pipe(
      ofType(platformManagerActions.getTenants),
      switchMap(({ page, pageSize}) =>
        this.platfromManagerService.getTenants(page, pageSize).pipe(
          map((tenants: Paginate<Tenant>) =>
            platformManagerActions.getTenantsSuccess({
              tenants,
            })
          )
        )
      )
    )
  );

  loadTenant$ = createEffect(() =>
    this.actions$.pipe(
      ofType(platformManagerActions.loadTenant),
      switchMap(({ tenant }) =>
        this.platfromManagerService.loadTenant(tenant).pipe(
          map((tenantRes: Tenant) =>
            platformManagerActions.loadTenantSuccess({
              tenant: tenantRes,
            })
          )
        )
      )
    )
  );
}
